"use client";
import { cn } from "@/lib";
import React, { ComponentProps, FC, PropsWithChildren } from "react";
import { useLockBodyScroll } from "@uidotdev/usehooks";
import AuthModalHeader from "./authModalHeader";
import { FlexCenter } from "@/components/ui/flexBox";
import { TFormMode } from "@/interfaces";
import { useModalStore } from "@/store";

interface IAuthModalContainer
  extends FC<PropsWithChildren<TAuthModalContainer>> {
  Skeleton: FC<PropsWithChildren>;
}
type TAuthModalContainer = {
  formMode?: TFormMode;
  className?: string;
} & ComponentProps<"div">;

const AuthModalContainer: IAuthModalContainer = ({
  children,
  formMode,
  ...props
}) => {
  const { closeModal } = useModalStore();
  useLockBodyScroll();

  return (
    <FlexCenter
      {...props}
      // onClick={closeModal}
      className={cn("fixed inset-0 z-50 bg-black/25", props.className)}
    >
      <div
        className={cn(
          "bg-surface flex w-full max-w-[300px] flex-col rounded-lg p-6 shadow-lg sm:max-w-sm md:max-w-md md:p-8",
          "sm:my-auto sm:max-h-[600px]",
          "mt-0 max-h-none sm:max-h-[600px]",
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <AuthModalHeader formMode={formMode} handleClose={closeModal} />
        {children}
      </div>
    </FlexCenter>
  );
};

AuthModalContainer.Skeleton = ({ children }) => (
  <FlexCenter className={cn("fixed inset-0 z-20 bg-black/25")}>
    <div
      className={cn(
        "bg-surface flex w-full max-w-md animate-pulse flex-col rounded-lg p-8 shadow-lg",
        "sm:my-auto sm:min-h-[500px]",
        "min-h-none mt-0 sm:min-h-[500px]",
      )}
    >
      <AuthModalHeader.Skeleton /> {children}
    </div>
  </FlexCenter>
);

export default AuthModalContainer;
